import Axios from 'axios';

/*
 * Defination of all Rest methods
 */
export const getRequest = async (url: any, params = {}, header: any) => {
  return await Axios({
    method: 'get',
    url: url,
    params: params,
    headers: {
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': 'http://localhost:3000'
      // user_id: HEADER_TYPE.userId,
    },
  });
};

export const postRequest = async (
  url: any,
  data: any,
  header: any,
  params = {},
  isFile?: boolean
) => {
  if (isFile) {
    return await Axios({
      method: 'post',
      url: url,

      data,
      params,
      headers: header,
    });
  }
  return await Axios({
    method: 'post',
    url: url,
    data,
    params,
    headers: header,
  });
};

export const putRequest = async (
  url: any,
  data: any,
  header: any,
  params = {}
) => {
  return await Axios({
    method: 'put',
    url: url,
    data: data,
    params: params,
    headers: {
      'Content-Type': 'application/json',
      // user_id: HEADER_TYPE.userId,
    },
  });
};

export const deleteRequest = async (
  url: any,
  data: any,
  header: any,
  params = {}
) => {
  return await Axios({
    method: 'delete',
    url: url,
    data: data,
    params: params,
    headers: {
      'Content-Type': 'application/json',
      // user_id: HEADER_TYPE.userId,
    },
  });
};
